import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { ITempControllSetting } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import { Tab } from "./ModalManage";

export default function Log ({
    unit,
    item,
    activeTab
}: {
    unit: string;
    item: ITempControllSetting;
    activeTab: Tab;
}) {

    const [data, setData] = useState([]);

    useEffect(() => {
        if (!item || activeTab !== 'LOG') return;

        const { location } = item;
        const getLogData = async () => {
            try {
                const res = await apiClient.get(`/tempControl/logs?location=${location}&unit=${unit}`);
                setData(res.data);
            } catch (err) {
                alert(err);
            }
        }
        getLogData();
    }, [item, activeTab]);
    
    if (!item) return null;

    return (
        <div>
            <VirtualTable 
                data={data}
                mapping={[{
                    name: 'Modified By',
                    value: 'modifiedBy',
                    email: true
                }, {
                    name: 'Modified At',
                    value: 'modifiedAt',
                    datetime: true
                }, {
                    name: `Setting in °Celsius`,
                    value: 'setting',
                    number: true
                }]}
                numRows={10}
            />
        </div>
    );
}

